// extracted by mini-css-extract-plugin
export default {"main":"Main_main__R-PT5","wideCards":"Main_wideCards__5i9qQ","compactCards":"Main_compactCards__mTuue"};